import React from 'react';
import { bool, func, object } from 'prop-types';
import { ModalStyled } from '@nike/nike-design-system-components';
import { CheckCircle, AlertCircle } from '@nike/nike-design-system-icons';

import { ModalHeaderIcon } from '../catalogs/catalogStyles';

const StatusModal = ({ isOpen, closeModal, modalProps, ...props }) => {
  const { type, title, message } = modalProps;
  return (
    <ModalStyled
      Icon={type === 'success' ? CheckCircle : AlertCircle}
      isOpen={isOpen}
      closeModal={closeModal}
      title={title}
      IconWrapper={ModalHeaderIcon}
      backdropCompProps={{ style: { backdropFilter: 'blur(4px)' } }}
      {...props}
    >
      {message}
    </ModalStyled>
  );
};

StatusModal.defaultProps = {
  modalProps: { title: '' }
};

StatusModal.propTypes = {
  isOpen: bool.isRequired,
  closeModal: func.isRequired,
  modalProps: object
};

export default StatusModal;
